import React from 'react';
import { useDispatch } from 'react-redux';

import { setLanguage as setLanguageAction } from '@src/store/ui/actions';
import { Language } from '@src/store/ui/types';

import useLanguage from './useLanguage';

const useLanguageState = () => {
  const dispatcher = useDispatch();
  const language = useLanguage();
  const setLanguage = React.useCallback(
    (newLanguage: Language) => dispatcher(setLanguageAction(newLanguage)),
    [dispatcher]
  );

  return React.useMemo(() => {
    return { language, setLanguage };
  }, [language, setLanguage]);
};

export default useLanguageState;
